import { render, staticRenderFns } from "./DeletedAssets.vue?vue&type=template&id=fb5498b2&scoped=true&"
import script from "./DeletedAssets.vue?vue&type=script&lang=js&"
export * from "./DeletedAssets.vue?vue&type=script&lang=js&"
import style0 from "./DeletedAssets.vue?vue&type=style&index=0&id=fb5498b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5498b2",
  null
  
)

export default component.exports